export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#08080A] border-t border-white/8 pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Massive brand type */}
        <div className="relative mb-16">
          <div className="font-display text-[18vw] md:text-[13vw] leading-[0.85] tracking-tighter text-neutral-50 select-none">
            RUDRA<span className="italic text-[#D4AF37]"> Empire.</span>
          </div>
          <div className="mt-2 font-display italic text-xl md:text-3xl text-[#D4AF37]">
            Welcome to the World of Business.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/8">
          <div className="md:col-span-5">
            <div className="overline mb-4">The House of Rudra</div>
            <p className="text-neutral-400 max-w-md leading-relaxed">
              A private Karnataka land house, working quietly since 1995 —
              acquiring land from individuals and delivering it, cleanly, to
              Government bodies and multinational corporations.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <div className="overline mb-4">Sitemap</div>
            <ul className="space-y-3 text-sm text-neutral-300">
              {[
                ["What We Do", "#business"],
                ["Karnataka", "#karnataka"],
                ["Legacy", "/house-of-rudra"],
                ["Leadership", "#leadership"],
                ["Contact", "#contact"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a
                    data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
                    href={h}
                    className="link-gold"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">Correspondence</div>
            <a
              data-testid="footer-email-link"
              href="mailto:info@rudraempire.com"
              className="link-gold text-sm text-neutral-300"
            >
              info@rudraempire.com
            </a>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-xs tracking-widest uppercase text-neutral-500">
          <div>© {new Date().getFullYear()} Rudra Empire. All rights reserved.</div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
            <a
              data-testid="footer-privacy-link"
              href="/privacy"
              className="link-gold"
            >
              Privacy
            </a>
            <span className="text-neutral-700">·</span>
            <a
              data-testid="footer-terms-link"
              href="/terms"
              className="link-gold"
            >
              Terms
            </a>
            <span className="text-neutral-700">·</span>
            <a
              data-testid="footer-disclaimer-link"
              href="/disclaimer"
              className="link-gold"
            >
              Disclaimer
            </a>
          </div>
        </div>
        <div className="pt-6 text-[0.65rem] tracking-widest uppercase text-neutral-600">
          Est. 1995 · Founded by Sri Rudra Singh · Chaired by Dr. Anurag Singh
        </div>
      </div>
    </footer>
  );
}
